<template>
  <div
    class="a4-container"
    id="pdf-content"
    style="font-family: Arial, sans-serif !important"
    v-if="ui_setting"
  >
    <!-- <h1>Page 1 english</h1> -->
    <div
      v-for="(item, textIndex) in ui_setting.texts"
      :key="'div1' + textIndex + item.id"
      style="
        position: absolute;
        text-align: center;
        font-family: Arial, sans-serif !important;
      "
      :style="
        'left: ' +
        item.x * 1.3 +
        'px ;bottom: ' +
        item.y * 1.1 +
        'px;font-size: ' +
        item.fontSize +
        'pt;' +
        (item.isBold ? 'font-weight: bold;' : '') +
        (item.isUppercase ? 'text-transform: uppercase;' : '')
      "
    >
      <!-- <template v-if="item.text != '%%'">{{ getText(item) }}</template> -->
      <template v-if="Array.isArray(getText(item))">
        <span style="font-weight: bold">{{ getText(item)[0] }} </span>
        <span style="font-weight: normal">{{ getText(item)[1] }}</span>
      </template>
      <span v-else-if="item.text != '%%'">
        {{ getText(item) }}
      </span>
    </div>

    <div
      v-for="(item, textIndex) in ui_setting.texts"
      :key="'div2' + textIndex + item.id"
      style="
        position: absolute;
        text-align: center;
        left: 50%;
        transform: translate(-50%, -50%);
        font-family: Arial, sans-serif !important;
      "
      :style="
        'bottom: ' +
        item.y * 1.1 +
        'px;font-size: ' +
        item.fontSize +
        'pt;' +
        (item.isBold ? 'font-weight: bold;' : '') +
        (item.isUppercase ? 'text-transform: uppercase;' : '')
      "
    >
      <template v-if="item.text == '%%'">
        <div
          :style="
            'left: ' +
            item.x * 1.3 +
            'px ;bottom: ' +
            item.y * 1.1 +
            'px;font-size: ' +
            item.fontSize +
            'pt;'
          "
        >
          <span style="display: block">
            <span style="text-transform: uppercase; font-weight: bold">
              {{ student.xprofession.xprofessiondegree.shortName }} of
            </span>
            <span style="font-weight: bold" v-if="student.xprofession.nameEN">{{
              student.xprofession.nameEN.toUpperCase()
            }}</span>
          </span>
          IN
          <span style="font-weight: bold" v-if="student.xcurriculum.nameEN">{{
            student.xcurriculum.nameEN.toUpperCase()
          }}</span>
        </div></template
      >
    </div>
  </div>
</template>

<script>
import { PageSizes } from "pdf-lib";
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");
export default {
  data() {
    return {
      height: PageSizes[0],
      width: PageSizes[1],
    };
  },
  // computed: {
  //   ...mapState(["userProfile", "currentUser", "xxschoolPath"]),
  // },
  methods: {
    getText(text) {
      this.student.currentDate =
        new Date().toLocaleString("default", { month: "long" }) +
        " " +
        new Date().getDate() +
        ", " +
        new Date().getFullYear();

      if (text.text) {
        if (text.isUpperCase) {
          text.text = text.text.toUpperCase();
          if (text.nextVariableName && this.student[text.nextVariableName])
            this.student[text.nextVariableName] =
              this.student[text.nextVariableName].toUpperCase();
        }

        return text.nextVariableName
          ? text.text + " " + this.student[text.nextVariableName]
          : text.text;
      } else if (text.isVariable) {
        var tmpText = this.student[text.variableName]
          ? this.student[text.variableName].toString()
          : "";
        if (text.isUpperCase) tmpText = tmpText.toUpperCase();
        if (this.student[text.nextVariableName]) {
          tmpText = tmpText + " " + this.student[text.nextVariableName];
        }
        if (text.nextVariableName == "lastNameEN") {
          return [
            this.student[text.variableName],
            this.student[text.nextVariableName],
          ];
        } else {
          return tmpText;
        }
        // if (text.nextVariableName) {
        //   student[text.nextVariableName],
        //     {
        //       x: text.x+100,
        //       y: text.y,
        //       font: ubuntuFont,
        //       size: text.fontSize ? text.fontSize : 12,
        //     };
        // }
      }
    },
  },
  created() {
    console.log(this.student.xprofession);
  },
  props: {
    student: {
      required: true,
      type: Object,
    },
    ui_setting: {
      required: true,
      type: Object,
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: landscape;
    margin: 0;
  }

  body {
    margin: 0;
  }
}
.btable {
  border-collapse: collapse;
  border: 1px solid black;
}
.btable th,
td {
  border: 1px solid black;
  padding: 8px;
}

.a4-container {
  position: relative;
  width: 29.7cm;
  height: 21cm;
  border: 1px solid black;
  margin: 0 auto;
}
.a4-container .main-text {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  margin: 0 auto;
  box-sizing: border-box;
}

.a4-container .bottom-container {
  position: relative;
  bottom: 100px;
  display: flex;
  justify-content: space-between;
  height: 100px;

  padding-left: 40px;
  padding-right: 40px;
}

.a4-container .bottom-container .signature {
  border-top: 1px solid black;
  padding-top: 4px !important;
  margin-left: 30px;
  margin-right: 30px;
  width: 33%;
}
.signature .pclass {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.a4-container .head-score-page {
  position: relative;
  top: 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid black;
}

.a4-container .score-main {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid red;
}
.a4-container .head-score-page .title-column {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .head-score-page .title-column .column-text {
  text-align: left;
  padding: 2px;
  width: 50%;
  background-color: lightgray;
}
.a4-container .score-main .score-table-column {
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .score-signature-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid blue;
}
.a4-container .score-signature-container .score-signature {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 40%;
  background-color: lightgray;
}
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid black;
  padding: 8px;
}
.title-column .upper {
  text-transform: uppercase;
  font-weight: bold;
}
</style>
